import dayjs from "@/helpers/dayjs";
import ExcelDownload from "@/components/modal/ExcelDownload/index.vue";
import "dayjs/locale/ko";
import mobileList from "@/components/order/MobileList/layout.vue";
import mixinFilter from "@/mixins/mixinFilter";
import customSelect from "@/components/common/CustomSelect/layout.vue";

export default {
  metaInfo: {
    title: "구성원 주문내역"
  },
  components: {
    ExcelDownload,
    mobileList,
    customSelect
  },
  computed: {},
  mixins: [mixinFilter],

  data() {
    return {
      modal: {
        excel: false
      },
      orders: [],
      tableOrders: [],
      orderDetailModalStatus: false,
      selectedOrderId: null,
      totalRow: 1,
      isLoading: false,
      perPageOption: 10,
      options: [
        { value: 10, title: "10개씩" },
        { value: 50, title: "50개씩" },
        { value: 100, title: "100개씩" }
      ]
    };
  },
  methods: {
    countItems(item) {
      let count = 0;
      let result = "";

      for (const key in item) {
        const value = item[key];
        if (key !== "weight" && key !== "fragile") {
          if (key === "etc" && value !== null && value !== "") {
            count++;
            if (count >= 2) {
              return "여러개";
            }
            result = `${this.mixinsItemTitle(key)}`;
          }
          if (key !== "etc" && value > 0) {
            count++;
            if (count >= 2) {
              return "여러개";
            }
            result = `${this.mixinsItemTitle(key)} ${item[key]}개`;
          }
        }
      }

      return result;
    },
    optionsCarRequired(order) {
      if (order.options.indexOf("bike") !== -1) return false;
      return true;
    },
    cancelable(status) {
      const available = ["registered", "reviewed", "bid_end", "confirmed"];
      if (available.indexOf(status) !== -1) return true;
      return false;
    },
    async cancelOrder(orderId) {
      if (orderId) {
        alert("주문 취소를 원하시면 고객센터로 전화주세요");
        return;
      }
    },
    openOrderDetailModal(orderId) {
      this.selectedOrderId = orderId;
      this.orderDetailModalStatus = true;
    },
    closeModal() {
      this.orderDetailModalStatus = false;
    },
    async getOrders(pass) {
      this.isLoading = true;
      const p = this.$route.query.p ? this.$route.query.p : 1;
      const perPage = this.$route.query.perPage
        ? this.$route.query.perPage
        : this.perPageOption;
      // this.orders = [];

      this.tableOrders = [];
      try {
        const orders = await this.$store.dispatch("orders/memberOrders", {
          perPage: perPage,
          currentPage: p
        });
        for (let i = 0; i < orders.orders.length; i++) {
          const order = orders.orders[i];

          this.tableOrders.push({
            orderTime: dayjs(order.orderTime).format("YYYY-MM-DD hh:mm"),
            // orderTime: order.orderTime,
            id: `#${order._id}`,
            applicant: "정보없음",
            notifiedPrice: order.notifiedPrice.toLocaleString() + "원",
            departure: order.pins[0].dongName,
            destination: order.pins[order.pins.length - 1].dongName,
            options: "오토바이 / 3Kg",
            status: this.$statusToKor(order.status)
            // action,
          });
        }
        this.orders = [];
        this.orders = orders.orders;
        this.totalRow = orders.total ? orders.total : 1;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        alert("서버에러가 발생하였습니다(2)");
        console.error(error);
      }
    },
    async pagination(val) {
      const totalPage = Math.ceil(this.totalRow / this.perPageOption);
      if (val == -1 && this.p == 1) {
        alert("첫 번째 페이지 입니다");
        return;
      }

      if (val === 1 && this.p == totalPage) {
        alert("마지막 페이지 입니다");
        return;
      }

      const newP = parseInt(this.p, 10) + val;
      this.$router.push(`?p=${newP}&perPage=${this.perPageOption}`);
    }
  },
  mounted() {
    if (this.$store.getters["auth/tokenPayload"]().type === "member") {
      return this.$router.push("/orders/list/my");
    }
    this.perPageOption = this.$route.query.perPage
      ? this.$route.query.perPage
      : this.perPageOption;
    this.orders = null;
    this.getOrders();
  },
  watch: {
    p() {
      return this.getOrders();
    },
    perPageOption() {
      this.$router.push(`?p=${1}&perPage=${this.perPageOption}`);
    },
    perPage() {
      return this.getOrders();
    }
  },
  props: ["p", "perPage"]
};
